import type { GetHashtags200Page } from './getHashtags200Page';

export type GetHashtags200 = {
  code?: string;
  message?: string;
  page?: GetHashtags200Page;
  success?: boolean;
};
